import React from 'react';

const NetworkCrossedIcon = () => (
  <svg
    width="24px"
    height="24px"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1162.201 1062.99"
  >
    <path
      fill="rgb(103, 120, 146)"
      d="M1090.201 600.272v-25.555c0-14.119-11.437-25.555-25.556-25.555H617.433v-63.888H732.43c28.223 0 51.11-22.888 51.11-51.11v-204.44c0-28.222-22.888-51.11-51.11-51.11H425.77c-28.223 0-51.11 22.888-51.11 51.11v204.44c0 28.223 22.888 51.11 51.11 51.11h114.997v63.888H93.555c-14.12 0-25.556 11.436-25.556 25.555v25.555c0 14.119 11.436 25.555 25.556 25.555h166.107v63.888H170.22c-28.223 0-51.11 22.888-51.11 51.11v204.44c0 28.222 22.888 51.109 51.11 51.109h255.55c28.223 0 51.11-22.888 51.11-51.109v-204.44c0-28.223-22.888-51.11-51.11-51.11h-89.442v-63.888h485.545v63.888H732.43c-28.223 0-51.11 22.888-51.11 51.11v204.44c0 28.222 22.888 51.109 51.11 51.109h255.55c28.223 0 51.11-22.888 51.11-51.109v-204.44c0-28.223-22.888-51.11-51.11-51.11h-89.442v-63.888h166.107c14.119 0 25.556-11.435 25.556-25.555zm-613.32-217.217v-102.22H681.32v102.22H476.881zm-102.221 511.1H221.33v-102.22h153.33v102.22zm562.211 0h-153.33v-102.22h153.33v102.22z"
    />
    <path fill="none" d="M267.6 212.995l880.5 880.5" />
    <g>
      <path
        fill="none"
        stroke="rgb(103, 120, 146)"
        strokeMiterlimit="10"
        strokeWidth="50"
        d="M68.6 175.995l1021 822"
      />
    </g>
  </svg>
);

export default NetworkCrossedIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/NetworkCrossedIcon.js